<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_Ssc_BaseUrl')" prop="base_url">
      <el-input
        v-model="model.params.base_url"
        :placeholder="$t('ChannelConfig_Ssc_BaseUrl_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Ssc_SecretKey')" prop="key">
      <el-input
        v-model="model.params.key"
        :placeholder="$t('ChannelConfig_Ssc_SecretKey_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Ssc_PostbackAccount')"
      prop="account"
    >
      <el-input
        v-model="model.account"
        :placeholder="$t('ChannelConfig_Ssc_PostbackAccount_Placeholder')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'ssc')
      this.$set(this.model, 'account', '')
      this.$set(this.model, 'params', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Ssc.vue